export default {
  pickupStudentList: [],
  studentListNoFilter: [],
  dropStudentList: {},
  dropRouteTimes: {},
  masterData: {},
  studentTemplate:{},
  isSave: false,
  pickupStudentListUpdate : {},
  pickupRouteTimes: {},
  pickupStudentTemplate: {},
  isSavePickup: false
}
